import { render, staticRenderFns } from "./AdicionarProdutoPaginaRevista.vue?vue&type=template&id=37788711"
import script from "./AdicionarProdutoPaginaRevista.vue?vue&type=script&lang=ts"
export * from "./AdicionarProdutoPaginaRevista.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports